import { render, staticRenderFns } from "./Examin.vue?vue&type=template&id=eabfc20e&scoped=true&"
import script from "./Examin.vue?vue&type=script&lang=js&"
export * from "./Examin.vue?vue&type=script&lang=js&"
import style0 from "./Examin.vue?vue&type=style&index=0&id=eabfc20e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabfc20e",
  null
  
)

export default component.exports